import { ContextType, RendererDescription } from '@data/models';


export const defaultRendererDescription: RendererDescription = {
  contextType: ContextType.WebGL,
  pixelRatio: window.devicePixelRatio,
  antialias: true
};
